<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="#"></b-link>

    <button class="navbar-toggler sidebar-toggler d-md-down-none mr-auto" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-navbar-nav class="ml-auto">
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <i class="fa fa-user fa-lg"></i>
        </template>
        <b-dropdown-header tag="div" class="text-center"><strong>Account - {{account_num}}</strong></b-dropdown-header>
        <b-dropdown-item @click="goToMyProfile"><i class="fa fa-user"></i> My Profile </b-dropdown-item>
        <b-dropdown-item @click="userLogout"><i class="fa fa-lock"></i> Logout <strong><i class="mx-2">{{user_name}}</i></strong></b-dropdown-item>
      </b-nav-item-dropdown>
      <a href="https://mportal.marketscan.com/help/index.html#/Intro" v-if="$route.path.indexOf('/mGauge/')<0" title="Help Documentation" target="_blank"><i class="fa fa-question-circle fa-lg mr-4 ml-2"></i></a>
      <a href="https://marketscan.atlassian.net/servicedesk/customer/portals" v-if="$route.path.indexOf('/mGauge/')>=0" title="Help Documentation">
        <img src="../assets/mgauge-help-logo30px.jpg" alt="mGuage Logo" class="img-fluid mr-2" style="height:25px;" >
      </a>
    </b-navbar-nav>
    <div class="alert alert-info my-auto h-100" role="alert">
      Your session will expire in {{expTime}} minutes
    </div>
    <!--<button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">
    <span class="navbar-toggler-icon"></span>
  </button>-->
  </header>
</template>
<script>
import Vue from 'vue'
import router from '@/router'
import VueCookies from 'vue-cookies'
import tokenexpiration from '@/shared/tokenexpiration'

Vue.use(VueCookies)

export default {
  name: 'c-header',
  created () {
    tokenexpiration.setCookiesTime(this)
  },
  data () {
    return {
      account_num: sessionStorage.getItem('account'),
      user_name: sessionStorage.getItem('login'),
      expTime: tokenexpiration.getTimeoutMinutes()
    }
  },
  beforeDestroy () {
    tokenexpiration.beforeDestroy(this)
  },
    methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    userLogout () {
      router.push('/logout')
    },
    goToMyProfile () {
      router.push('/MyProfile')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue